
export class ValidateUserWithPasswordRequestModel { 
    /**
     * License Number requiring 2 letters followed by 9 numbers
     */
    licenseNo: string;
    /**
     * User password
     */
    password: string;
    /**
     * IP address of the client
     */
    visitorIPAddress: string;
}



// WEBPACK FOOTER //
// ./src/app/model/validateUserWithPasswordRequestModel.ts